export const DOCUMENT_CRUNCH_EMAIL_DOMAIN = 'documentcrunch.com'

export const HIGH_SECURITY_ENTITLEMENT = 'high_security'

export const HIGH_SECURITY_WARNING_STORAGE_KEY_PREFIX =
  'dc-high-security-warning-dismissed'
